import balanceText from 'balance-text'
import PropTypes from 'prop-types'
import React, { useLayoutEffect, useRef } from 'react'

const BalanceText = ({ children }) => {
  const ref = useRef()

  // Ensure we always throw away the span and render a new one
  // if something changes, or else we could end up with duplicate
  // content in the span.
  const key = Date.now()

  useLayoutEffect(() => {
    balanceText(ref.current, { watch: true })
  }, [ref.current])

  if (React.Children.count(children) === 1) {
    return React.cloneElement(React.Children.only(children), { ref, key })
  }

  return (
    <span ref={ref} key={key}>
      {children}
    </span>
  )
}

BalanceText.propTypes = {
  children: PropTypes.any,
}

export default BalanceText
